import request from '../utils/request';
const querystring = require('querystring')
//获取系统名称 
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/common/getMemData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const getMemData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/common/getMemData.do',
        method: 'post',
        data: querystring.stringify(query)
        
    }); 
    return list;
};

//获取消息
export const getMessage = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMessage/getSystemMessage.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};


